import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '../../../../../shared/components/icon/icon.component';
import { ProgressRingComponent } from '../../../../../shared/components/progress-ring/progress-ring.component';
import type { CourseContentSidebarLessonItem } from '../../../../../shared/models/interfaces/sidebar.interface';
import { LessonStatus } from '../../../../../shared/models/enums/lesson-status.enum';

@Component({
  selector: 'l-sidebar-lesson-item',
  standalone: true,
  imports: [CommonModule, IconComponent, ProgressRingComponent],
  templateUrl: './sidebar-lesson-item.component.html',
})
export class SidebarLessonItemComponent {

  @Input({ required: true })
  public lesson!: CourseContentSidebarLessonItem;

  @Input()
  public isLast: boolean = false;

  @Input()
  public isOpen: boolean = true;

  @Input()
  public canAccess: boolean = false;

  @Input()
  public isSelected: boolean = false;

  @Output()
  public lessonSelected: EventEmitter<void> = new EventEmitter<void>();

  public lessonStatus: typeof LessonStatus = LessonStatus;

  public getLessonProgress(): number {
    const progress = this.lesson.lessonProgress ?? 0;
    return Math.min(100, Math.max(0, Math.round(progress)));
  }

  public lessonIcon(status: LessonStatus): string {
    return status === LessonStatus.COMPLETED ? 'check' : 'play_arrow';
  }

  public formatDuration(minutes: number): string {
    const totalSeconds = Math.max(0, Math.round((minutes || 0) * 60));
    const safeMinutes = Math.floor(totalSeconds / 60);
    const safeSeconds = totalSeconds % 60;
    return `${safeMinutes.toString().padStart(2, '0')}:${safeSeconds.toString().padStart(2, '0')}`;
  }

  public onClick(): void {
    if (this.canAccess) this.lessonSelected.emit();
  }
}
